import React from 'react';
import SearchAutocomplete from '../../../search-autocomplete';
import { Option } from '../../../search-autocomplete/types';
import { useIsStuck } from '../../hooks';
import AgentTypeFilter from '../agent-type-filter/agent-type-filter';
import SearchTypeToggle from '../search-type-toggle/search-type-toggle';
import * as styles from '../../search-results-2026.style';

export interface SearchStickyBarProps {
  isAgency: boolean;
  currentAgentType: string;
  selectedSuburbsKey: string;
  initialSelectedOption: Option[];
  selectSuburbs: (options: Option[]) => void;
  selectSearchType: (view: string) => void;
  selectAgentType: (agentFilter: string) => void;
  onOpenFilters: () => void;
  onAgentTypeSearchSubmit: (agentFilter: string) => void;
}

// Isolated so the scroll-driven `isStuck` state (used only to toggle an
// elevation shadow) doesn't re-render the rest of the search results page.
const SearchStickyBar = ({
  isAgency,
  currentAgentType,
  selectedSuburbsKey,
  initialSelectedOption,
  selectSuburbs,
  selectSearchType,
  selectAgentType,
  onOpenFilters,
  onAgentTypeSearchSubmit,
}: SearchStickyBarProps): JSX.Element => {
  const [isStuck, searchBarRef] = useIsStuck<HTMLDivElement>();

  return (
    <div ref={searchBarRef} css={styles.searchBar(isStuck)}>
      <div css={[styles.wrapper, styles.searchBarInner]}>
        <div css={styles.typeahead}>
          <SearchAutocomplete
            key={selectedSuburbsKey}
            useTypeaheadV5
            isLocationSearchByAgent
            recentSearches
            suggestedSuburbs
            initialSelectedOption={initialSelectedOption}
            performSearchQuery={selectSuburbs}
          />
        </div>
        <div css={styles.filterGroup}>
          <SearchTypeToggle isAgency={isAgency} onSelect={selectSearchType} />
          {!isAgency && (
            <AgentTypeFilter
              currentAgentType={currentAgentType}
              onSelect={selectAgentType}
              onOpenFilters={onOpenFilters}
              onSearchSubmit={onAgentTypeSearchSubmit}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchStickyBar;
